/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from 'react';
import { processCustomDoubtDetails } from '@api/processors/custom-doubts';
import useFetch from '@hooks/useFetch';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn, getMeUserId } from '@api/selectors/auth';
import useDoubtDetailsWithoutAuth from './useDoubtDetailsWithoutAuth';

const useDoubtDetails = (
  goalUID,
  doubtUID,
  options = { fallbackData: undefined },
  selectorFunc = null
) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const userId = useMyInfo(getMeUserId);
  const { doubtDetailsData: doubtDetailsDataWithoutAuth } =
    useDoubtDetailsWithoutAuth(goalUID, doubtUID);
  const isAuthorisedForDoubt =
    isLoggedIn && userId === doubtDetailsDataWithoutAuth?.doubtOwnerUID;
  const key = `v2/doubts/learner/details?add_title_and_tag=true&doubt_uid=${doubtUID}&goal_uid=${goalUID}&is_fast_doubts_flow=true`;
  const {
    data: doubtDetailsData,
    mutate,
    ...rest
  } = useFetch(
    isAuthorisedForDoubt ? key : null,
    { useCamelCase: false },
    { fallbackData: options.fallbackData }
  );

  const processedDoubtDetails = useMemo(
    () =>
      doubtDetailsData?.errorCode
        ? doubtDetailsData
        : processCustomDoubtDetails(doubtDetailsData, options.isSelectedReset),
    [doubtDetailsData, processCustomDoubtDetails, options.isSelectedReset]
  );

  if (typeof selectorFunc === 'function')
    return selectorFunc(processedDoubtDetails);

  return {
    key,
    mutate,
    doubtDetailsData: processedDoubtDetails,
    ...rest
  };
};

export default useDoubtDetails;
